/* eslint-disable react-refresh/only-export-components */
import { TRUST_SCORE_THRESHOLD } from '@shared/data/mocks/mockCredentials';
import { createApplicationStore, emptyDeMinimisCheck, type DemoState, type Municipality } from '@shared/application/state';
export * from '@shared/application/state';

export const municipalities: Municipality[] = [
  { id: 'oslo', name: 'Oslo kommune', region: 'Oslo' },
  { id: 'baerum', name: 'Bærum kommune', region: 'Akershus' },
  { id: 'lillestrom', name: 'Lillestrøm kommune', region: 'Akershus' },
  { id: 'bergen', name: 'Bergen kommune', region: 'Vestland' },
  { id: 'trondheim', name: 'Trondheim kommune', region: 'Trøndelag' },
  { id: 'stavanger', name: 'Stavanger kommune', region: 'Rogaland' },
];

function createVariantInitialState(): DemoState {
  return {
    loggedIn: false,
    role: 'startup',
    project: {
      companyName: 'EcoWaste Tech AS',
      organizationNumber: '912 345 678',
      title: 'Smart avfallshåndtering for kommuner',
      shortDescription: 'Sensorer og prognoser som reduserer unødvendig tømming av kommunalt avfall.',
      problem: 'Kommuner bruker tid, kjøretøy og utslipp på å tømme beholdere etter faste ruter, uavhengig av faktisk fyllingsgrad.',
      solution: 'Løsningen kombinerer sensordata og prognoser for å foreslå behovsstyrte ruter og dokumentere effekten av piloten.',
      desiredCollaboration: 'Vi søker kommuner som vil teste løsningen i ett avgrenset område og dele driftsdata og erfaringer.',
    },
    funding: {
      financing: {
        startupContribution: 650_000,
        municipalityContribution: 0,
        requestedGrant: 1_500_000,
      },
      startupCosts: {
        lonn: 1_050_000,
        eksterneTjenester: 500_000,
        utstyrOgMaterialer: 600_000,
        reiseOgMoter: 0,
        kommunikasjon: 0,
        andreUtgifter: 0,
      },
      municipalityCosts: {
        lonn: 0,
        eksterneTjenester: 0,
        utstyrOgMaterialer: 0,
        reiseOgMoter: 0,
        kommunikasjon: 0,
        andreUtgifter: 0,
      },
    },
    deMinimisCheck: emptyDeMinimisCheck(1_500_000),
    deMinimisRetryCount: 0,
    walletProvider: 'mock',
    requestedProofKeys: [],
    sentCredentials: [],
    proofThreshold: TRUST_SCORE_THRESHOLD,
    partners: [],
    marketplaceStatus: 'draft',
    submitted: false,
    decisionStatus: 'idle',
  };
}

export const { DemoProvider, useDemo, demoReducer, createInitialState } =
  createApplicationStore(createVariantInitialState);
